let vAutoAnimate = {
  inserted: function (el, binding) {
    if (suport) {
      autoAnimateFun(el, binding.value || {})
    }
  }
}
let suport = false
let root = undefined
let mutations = undefined
let resize = undefined
const handleMutations = mutations => {
  const elements = getElements(mutations)
  // If elements is "false" that means this mutation that should be ignored.
  if (elements) {
    elements.forEach(el => animate(el))
  }
}
const handleResizes = entries => {
  entries.forEach(entry => {
    if (entry.target === root) updateAllPos()
    if (coords.has(entry.target)) updatePos(entry.target)
  })
}
try {
  if (
    typeof window !== 'undefined' &&
    typeof window.ResizeObserver === 'function' &&
    typeof window.MutationObserver === 'function'
  ) {
    suport = true
    root = document.documentElement
    mutations = new MutationObserver(handleMutations)
    resize = new ResizeObserver(handleResizes)
    resize.observe(root)
  }
} catch (error) {
  suport = false
}

const enabled = new WeakSet()
const options = new WeakMap()
const debounces = new WeakMap()
const animations = new WeakMap()
const coords = new WeakMap()
const intervals = new WeakMap()
const parents = new Set()
const intersections = new WeakMap()
const siblings = new WeakMap()

const TGT = '__aa_tgt'
const DEL = '__aa_del'

function autoAnimateFun(el, config = {}) {
  if (mutations && resize) {
    // 判断系统是否启用了系统级别的“减少动态效果”
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const isDisabledDueToReduceMotion =
      mediaQuery.matches && typeof config !== 'function' && !config.disrespectUserMotionPreference
    if (!isDisabledDueToReduceMotion) {
      enabled.add(el)
      if (getComputedStyle(el).position === 'static') {
        Object.assign(el.style, { position: 'relative' })
      }
      forEach(el, updatePos, poll, element => resize?.observe(element))
      if (typeof config === 'function') {
        options.set(el, config)
      } else {
        // 校验值
        for (const key in config) {
          if (['duration', 'offset', 'scale'].includes(key) && typeof config[key] !== 'number') {
            delete config[key]
          }
        }
        options.set(el, { duration: 250, easing: 'ease-in-out', ...config })
      }
      mutations.observe(el, { childList: true })
      parents.add(el)
    }
  }
  return Object.freeze({
    parent: el,
    enable: () => {
      enabled.add(el)
    },
    disable: () => {
      enabled.delete(el)
    },
    isEnabled: () => enabled.has(el)
  })
}

function forEach(parent, ...callbacks) {
  callbacks.forEach(callback => callback(parent, options.has(parent)))
  for (let i = 0; i < parent.children.length; i++) {
    const child = parent.children.item(i)
    if (child) {
      callbacks.forEach(callback => callback(child, options.has(child)))
    }
  }
}

function updatePos(el) {
  clearTimeout(debounces.get(el))
  const optionsOrPlugin = getOptions(el)
  const delay = typeof optionsOrPlugin === 'function' ? 500 : optionsOrPlugin.duration
  debounces.set(
    el,
    setTimeout(async () => {
      const currentAnimation = animations.get(el)

      try {
        await currentAnimation?.finished

        coords.set(el, getCoords(el))
        observePosition(el)
      } catch {
        // ignore errors as the `.finished` promise is rejected when animations were cancelled
      }
    }, delay)
  )
}
function getOptions(el) {
  const animationOptions = el && options.has(el[TGT]) ? options.get(el[TGT]) : { duration: 250, easing: 'ease-in-out' }
  return animationOptions
}
function poll(el) {
  setTimeout(() => {
    intervals.set(
      el,
      setInterval(() => lowPriority(updatePos.bind(null, el)), 2000)
    )
  }, Math.round(2000 * Math.random()))
}
function getCoords(el) {
  const rect = el.getBoundingClientRect()
  const { x, y } = getScrollOffset(el)
  return {
    top: rect.top + y,
    left: rect.left + x,
    width: rect.width,
    height: rect.height
  }
}
function getScrollOffset(el) {
  let p = el.parentElement
  while (p) {
    if (p.scrollLeft || p.scrollTop) {
      return { x: p.scrollLeft, y: p.scrollTop }
    }
    p = p.parentElement
  }
  return { x: 0, y: 0 }
}
function observePosition(el) {
  const oldObserver = intersections.get(el)
  oldObserver?.disconnect()
  let rect = coords.get(el)
  let invocations = 0
  const buffer = 5
  if (!rect) {
    rect = getCoords(el)
    coords.set(el, rect)
  }
  const { offsetWidth, offsetHeight } = root
  const rootMargins = [
    rect.top - buffer,
    offsetWidth - (rect.left + buffer + rect.width),
    offsetHeight - (rect.top + buffer + rect.height),
    rect.left - buffer
  ]
  const rootMargin = rootMargins.map(px => `${-1 * Math.floor(px)}px`).join(' ')
  const observer = new IntersectionObserver(
    () => {
      ++invocations > 1 && updatePos(el)
    },
    {
      root,
      threshold: 1,
      rootMargin
    }
  )
  observer.observe(el)
  intersections.set(el, observer)
}
function lowPriority(callback) {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => callback())
  } else {
    requestAnimationFrame(() => callback())
  }
}

function getElements(mutations) {
  const observedNodes = mutations.reduce((nodes, mutation) => {
    return [...nodes, ...Array.from(mutation.addedNodes), ...Array.from(mutation.removedNodes)]
  }, [])

  // Short circuit if _only_ comment nodes are observed
  const onlyCommentNodesObserved = observedNodes.every(node => node.nodeName === '#comment')

  if (onlyCommentNodesObserved) return false

  return mutations.reduce((elements, mutation) => {
    // Short circuit if we find a purposefully deleted node.
    if (elements === false) return false

    if (mutation.target instanceof Element) {
      target(mutation.target)
      if (!elements.has(mutation.target)) {
        elements.add(mutation.target)
        for (let i = 0; i < mutation.target.children.length; i++) {
          const child = mutation.target.children.item(i)
          if (!child) continue
          if (DEL in child) return false
          target(mutation.target, child)
          elements.add(child)
        }
      }
      if (mutation.removedNodes.length) {
        for (let i = 0; i < mutation.removedNodes.length; i++) {
          const child = mutation.removedNodes[i]
          if (DEL in child) return false
          if (child instanceof Element) {
            elements.add(child)
            target(mutation.target, child)
            siblings.set(child, [mutation.previousSibling, mutation.nextSibling])
          }
        }
      }
    }
    return elements
  }, new Set())
}

function animate(el) {
  const isMounted = el.isConnected
  const preExisting = coords.has(el)
  if (isMounted && siblings.has(el)) siblings.delete(el)
  if (animations.has(el)) {
    animations.get(el)?.cancel()
  }
  if (preExisting && isMounted) {
    remain(el)
  } else if (preExisting && !isMounted) {
    remove(el)
  } else {
    add(el)
  }
}

function updateAllPos() {
  clearTimeout(debounces.get(root))
  debounces.set(
    root,
    setTimeout(() => {
      parents.forEach(parent => forEach(parent, el => lowPriority(() => updatePos(el))))
    }, 100)
  )
}

function remain(el) {
  const oldCoords = coords.get(el)
  const newCoords = getCoords(el)
  if (!isEnabled(el)) return coords.set(el, newCoords)
  let animation
  if (!oldCoords) return
  const pluginOrOptions = getOptions(el)
  if (typeof pluginOrOptions !== 'function') {
    const deltaX = oldCoords.left - newCoords.left
    const deltaY = oldCoords.top - newCoords.top
    const [widthFrom, widthTo, heightFrom, heightTo] = getTransitionSizes(el, oldCoords, newCoords)
    const start = {
      transform: `translate(${deltaX}px, ${deltaY}px)`
    }
    const end = {
      transform: `translate(0, 0)`
    }
    if (widthFrom !== widthTo) {
      start.width = `${widthFrom}px`
      end.width = `${widthTo}px`
    }
    if (heightFrom !== heightTo) {
      start.height = `${heightFrom}px`
      end.height = `${heightTo}px`
    }
    animation = el.animate([start, end], {
      duration: pluginOrOptions.duration,
      easing: pluginOrOptions.easing
    })
  } else {
    animation = new Animation(pluginOrOptions(el, 'remain', oldCoords, newCoords))
    animation.play()
  }
  animations.set(el, animation)
  coords.set(el, newCoords)
  animation.addEventListener('finish', updatePos.bind(null, el))
}

function isEnabled(el) {
  const target = getTarget(el)
  return target ? enabled.has(target) : false
}
function getTarget(el) {
  if (TGT in el) return el[TGT]
  return undefined
}

function getTransitionSizes(el, oldCoords, newCoords) {
  let widthFrom = oldCoords.width
  let heightFrom = oldCoords.height
  let widthTo = newCoords.width
  let heightTo = newCoords.height
  const styles = getComputedStyle(el)
  const sizing = styles.getPropertyValue('box-sizing')

  if (sizing === 'content-box') {
    const paddingY =
      raw(styles.paddingTop) + raw(styles.paddingBottom) + raw(styles.borderTopWidth) + raw(styles.borderBottomWidth)
    const paddingX =
      raw(styles.paddingLeft) + raw(styles.paddingRight) + raw(styles.borderRightWidth) + raw(styles.borderLeftWidth)
    widthFrom -= paddingX
    widthTo -= paddingX
    heightFrom -= paddingY
    heightTo -= paddingY
  }
  return [widthFrom, widthTo, heightFrom, heightTo].map(Math.round)
}

function raw(str) {
  return Number(str.replace(/[^0-9.-]/g, ''))
}

function remove(el) {
  if (!siblings.has(el) || !coords.has(el)) return

  const [prev, next] = siblings.get(el)
  Object.defineProperty(el, DEL, { value: true })
  if (next && next.parentNode && next.parentNode instanceof Element) {
    next.parentNode.insertBefore(el, next)
  } else if (prev && prev.parentNode) {
    prev.parentNode.appendChild(el)
  } else {
    getTarget(el)?.appendChild(el)
  }
  function cleanUp() {
    el.remove()
    coords.delete(el)
    siblings.delete(el)
    animations.delete(el)
    intersections.get(el)?.disconnect()
  }
  if (!isEnabled(el)) return cleanUp()
  const [top, left, width, height] = deletePosition(el)
  const optionsOrPlugin = getOptions(el)
  const oldCoords = coords.get(el)
  let animation
  Object.assign(el.style, {
    position: 'absolute',
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
    margin: 0,
    pointerEvents: 'none',
    transformOrigin: 'center',
    zIndex: 100
  })
  if (typeof optionsOrPlugin !== 'function') {
    animation = el.animate(
      [
        {
          transform: `scale(${optionsOrPlugin.scale ? optionsOrPlugin.scale : 0.98})`,
          opacity: 1
        },
        {
          transform: 'scale(1)',
          opacity: 0
        }
      ],
      { duration: optionsOrPlugin.duration, easing: 'ease-out' }
    )
  } else {
    animation = new Animation(optionsOrPlugin(el, 'remove', oldCoords))
    animation.play()
  }
  animations.set(el, animation)
  animation.addEventListener('finish', cleanUp)
}
function add(el) {
  const newCoords = getCoords(el)
  coords.set(el, newCoords)
  const pluginOrOptions = getOptions(el)
  if (!isEnabled(el)) return
  let animation
  if (typeof pluginOrOptions !== 'function') {
    animation = el.animate(
      [
        { transform: `scale(${pluginOrOptions.scale ? pluginOrOptions.scale : 0.98})`, opacity: 0 },
        {
          transform: `scale(${pluginOrOptions.scale ? pluginOrOptions.scale : 0.98})`,
          offset: pluginOrOptions.offset || pluginOrOptions.offset == 0 ? pluginOrOptions.offset : 0.5,
          opacity: 0
        },
        { transform: 'scale(1)', opacity: 1 }
      ],
      {
        duration: pluginOrOptions.duration * 1.5,
        easing: 'ease-in'
      }
    )
  } else {
    animation = new Animation(pluginOrOptions(el, 'add', newCoords))
    animation.play()
  }
  animations.set(el, animation)
  animation.addEventListener('finish', updatePos.bind(null, el))
}
function deletePosition(el) {
  const oldCoords = coords.get(el)
  const [width, , height] = getTransitionSizes(el, oldCoords, getCoords(el))

  let offsetParent = el.parentElement
  while (
    offsetParent &&
    (getComputedStyle(offsetParent).position === 'static' || offsetParent instanceof HTMLBodyElement)
  ) {
    offsetParent = offsetParent.parentElement
  }
  if (!offsetParent) offsetParent = document.body
  const parentStyles = getComputedStyle(offsetParent)
  const parentCoords = coords.get(offsetParent) || getCoords(offsetParent)
  const top = Math.round(oldCoords.top - parentCoords.top) - raw(parentStyles.borderTopWidth)
  const left = Math.round(oldCoords.left - parentCoords.left) - raw(parentStyles.borderLeftWidth)
  return [top, left, width, height]
}

function target(el, child) {
  if (!child && !(TGT in el)) Object.defineProperty(el, TGT, { value: el })
  else if (child && !(TGT in child)) Object.defineProperty(child, TGT, { value: el })
}

const autoAnimate = {
  install: function (Vue) {
    Vue.directive('auto-animate', vAutoAnimate)
  }
}
export default autoAnimate
/**
 * binding的值可以为一个对象，可以有以下属性：
 * {duration：动画运行时间（毫秒ms）,
 * easing:动画效果类型，可以是 "linear"、"ease-in"、"ease-out"、"ease-in-out" 或其他自定义字符串，默认值为ease-in-outscale
 * scale：元素缩放比例，默认为'0.98'
 * offset: 元素显示时机，默认为0.5，值为0-1
 * disrespectUserMotionPreference：可选，是否忽略用户的“减少动态效果”选项，强制启用动画效果。不建议使用该选项
 * }
 */
